"use strict";Object.defineProperty(exports, "__esModule", {value: true});

// Enter and Space press a `role="button"` element the way they press a <button>.
// Keys pressed on a control nested inside it belong to that control alone.
 const onButtonKeyDown = (e) => {
  if (e.key !== 'Enter' && e.key !== ' ') return
  if (e.target !== e.currentTarget) return
  e.preventDefault()
  e.currentTarget.click()
}; exports.onButtonKeyDown = onButtonKeyDown
